import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

type TypographyWithFontWeight = {
    fontWeight: {
        light: number;
        default: number;
        bold: number;
        medium: number;
    };
};

export const useStyle = makeStyles()((theme) => {
    const typography = theme.typography as typeof theme.typography & TypographyWithFontWeight;

    return {
        container: {
            marginBottom: "77px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        banner: {
            backgroundColor: theme.palette.background.dark,
            borderRadius: theme.shape.borderRadius,
            paddingInline: theme.spacing(4),
            marginBottom: theme.spacing(4),
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: theme.spacing(3),
            width: "100%",
            [theme.breakpoints.down("md")]: {
                flexDirection: "column",
                textAlign: "center",
                padding: theme.spacing(0, 4, 6, 4),
            },
        },
        bannerContent: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
        },
        bannerContentContainer: {
            margin: "auto",
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(16),
            [theme.breakpoints.down("md")]: {
                gap: theme.spacing(4),
                flexDirection: "column-reverse",
            },
        },
        bannerImage: {
            maxWidth: "300px",
            width: "100%",
            height: "auto",
            transform: "scaleX(-1)",
        },
        title: {
            color: theme.palette.secondary.main,
        },
        subtitle: {
            color: theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            fontWeight: typography.fontWeight.light,
            fontSize: 32,
            [getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET)]: {
                fontSize: 30,
            },
            [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
                fontSize: 26,
            },
        },
        checkIcon: {
            width: "2em",
            height: "2em",
        },
        confirmationContainer: {
            paddingInline: theme.spacing(2),
            maxWidth: 700,
        },
        orderNumber: {
            color: theme.palette.secondary.main,
            fontWeight: typography.fontWeight.light,
            fontSize: 28,
            [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
                fontSize: 24,
            },
        },
        orderConfirmationEmail: {
            marginTop: theme.spacing(3),
        },
        backHomeButton: {
            marginTop: theme.spacing(3),
        },
    };
});
